import React from "react";
import "./term-service.css";

const TermsService = () => {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <h1>Terms and Service</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="terms-section">
        <h2>1. Use of Services</h2>
        <p>
          Our services are intended for educational and research purposes. By participating, you agree to use our resources responsibly and in compliance with applicable laws.
        </p>

        <h2>2. Donations</h2>
        <p>
          If you choose to make a donation or payment on our website, you agree to the following:
        </p>
        <ul>
          <li><strong>Accuracy:</strong> Ensure that all payment details provided are complete and accurate.</li>
          <li><strong>Refunds:</strong> Donations are generally non-refundable, except in cases of error or special circumstances, at our discretion.</li>
          <li><strong>Security:</strong> We strive to secure payment transactions but disclaim liability for unauthorized access via third-party payment processors.</li>
        </ul>

        <h2>3. Intellectual Property</h2>
        <p>
          All materials provided by us are the property of E-Techno Educational and Research Society. Unauthorized use, reproduction, or distribution is prohibited.
        </p>

        <h2>4. Code of Conduct</h2>
        <p>
          Participants must act respectfully and professionally during programs and interactions. Violations may result in removal from services.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p>
          We are not liable for any indirect or consequential damages arising from your use of our services or resources.
        </p>

        <h2>6. Modifications</h2>
        <p>
          We reserve the right to update these terms at any time. Changes will be effective upon posting.
        </p>
      </section>

      <footer className="terms-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsService;
